import sites from "./sites.json";

export const selectOptionsForSite = () => {
    const url = new URL(location.href);
    
    const check = [
        // pathname is more specific
        url.host + url.pathname,
        url.host,
    ];

    const key = check.find(key => sites[key]);

    if (key) {
        console.log('found site', key);
    } else {
        console.error('site not found in config');
    }

    return key ? sites[key] : null;
};
